<!-- Bulk One Time Costs -->
<table *ngIf="price_summary.one_time_costs" class="table-sm w-100">
  <thead class="row-cols-2">
    <th scope="col" class="h5 pb-2 fw-medium">
      {{ 'one_time_costs' | translate }}
      ({{ (is_employee_payable ? 'employee' : 'company') | translate }})
    </th>
    <th scope="col" class="text-end h5 pb-2 fw-medium">
      {{ price_summary.total_one_time_cost }}
    </th>
  </thead>
  <tbody class="table-group-divider border-light-subtle">
    <ng-container *ngIf="price_summary.bulk_order_additional_info?.bulk_onetime_device">
      <tr class="fw-medium">
        <td>
          {{ 'total_device_cost' | translate }}
          ({{ price_summary.bulk_order_additional_info?.bulk_quantity }} qty)
        </td>
        <td class="text-end">
          {{
            price_summary.bulk_order_additional_info?.bulk_onetime_device?.total_cost_to_currency
          }}
        </td>
      </tr>
      <tr>
        <td>
          {{
            price_summary.bulk_order_additional_info?.bulk_onetime_device?.name +
              ' - ' +
              price_summary.bulk_order_additional_info?.bulk_onetime_device?.description
          }}
          (x{{ price_summary.bulk_order_additional_info?.bulk_onetime_device?.quantity }}) &#64;
          {{
            price_summary.bulk_order_additional_info?.bulk_onetime_device
              ?.employee_cost_to_currency ||
              price_summary.bulk_order_additional_info?.bulk_onetime_device?.cost_to_currency
          }}
          <span
            *ngIf="
              price_summary.bulk_order_additional_info?.bulk_onetime_device?.additional_info
                ?.business_purpose
            "
          >
            <br />
            {{
              price_summary.bulk_order_additional_info?.bulk_onetime_device?.additional_info
                ?.business_purpose
            }}
          </span>
          <span
            *ngIf="
              price_summary.bulk_order_additional_info?.bulk_onetime_device?.additional_info?.option
            "
          >
            <br />
            {{ 'option' | translate }}:
            {{
              price_summary.bulk_order_additional_info?.bulk_onetime_device?.additional_info?.option
            }}
          </span>
        </td>
        <td class="text-end">
          <span
            *ngIf="
              is_employee_payable &&
              price_summary.bulk_order_additional_info?.bulk_onetime_device
                ?.employee_cost_to_currency
            "
            class="material-icons-outlined pe-2 card-icon cursor-default"
            placement="top"
            ngbTooltip="{{ 'employee_cost' | translate }}"
          >
            credit_card
          </span>
          {{
            price_summary.bulk_order_additional_info?.bulk_onetime_device?.total_cost_to_currency
          }}
        </td>
      </tr>
    </ng-container>
    <ng-container *ngIf="bulk_accessories_length">
      <tr class="fw-medium">
        <td>
          {{ 'total_add_ons_cost' | translate }}
          ({{ price_summary.bulk_order_additional_info?.bulk_accessories_quantity }} qty)
        </td>
        <td class="text-end">
          {{ price_summary.bulk_order_additional_info?.bulk_total_accessories_cost }}
        </td>
      </tr>
      <tr *ngFor="let add_on of price_summary.bulk_order_additional_info?.bulk_accessories">
        <td>
          {{ add_on.name }}
          (x{{ add_on.quantity }}) &#64;
          {{ add_on.employee_cost_to_currency || add_on.cost_to_currency }}
        </td>
        <td class="text-end">
          <span
            *ngIf="is_employee_payable && add_on.employee_cost_to_currency"
            class="material-icons-outlined pe-2 card-icon cursor-default"
            placement="top"
            ngbTooltip="{{ 'employee_cost' | translate }}"
          >
            credit_card
          </span>
          {{ add_on.total_cost_to_currency }}
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>

<!-- Bulk Recurring Costs -->
<table *ngIf="price_summary.recurring_costs" class="table-sm w-100 mt-2rem">
  <thead class="row-cols-2">
    <th scope="col" class="h5 pb-2 fw-medium">
      {{ 'recurring_costs' | translate }} ({{ 'company' | translate }})
    </th>
    <th scope="col" class="text-end h5 pb-2 fw-medium">
      {{ price_summary.total_recurring_cost }}/mo.
    </th>
  </thead>
  <tbody class="table-group-divider border-light-subtle">
    <ng-container
      *ngIf="price_summary.bulk_order_additional_info?.cost_per_bundle?.recurring_device_cost"
    >
      <tr class="fw-medium">
        <td>
          {{ 'total_device_cost' | translate }}
          ({{ price_summary.bulk_order_additional_info?.bulk_quantity }} qty)
        </td>
        <td class="text-end">
          {{
            price_summary.bulk_order_additional_info?.bulk_recurring_device?.total_cost_to_currency
          }}/mo.
        </td>
      </tr>
      <tr>
        <td>
          {{
            price_summary.bulk_order_additional_info?.bulk_recurring_device?.name +
              ' - ' +
              price_summary.bulk_order_additional_info?.bulk_recurring_device?.description
          }}
          (x{{ price_summary.bulk_order_additional_info?.bulk_recurring_device?.quantity }}) &#64;
          {{
            price_summary.bulk_order_additional_info?.bulk_recurring_device?.cost_to_currency
          }}/mo.
        </td>
        <td class="text-end">
          {{
            price_summary.bulk_order_additional_info?.bulk_recurring_device?.total_cost_to_currency
          }}/mo.
        </td>
      </tr>
    </ng-container>

    <ng-container *ngIf="price_summary.bulk_order_additional_info?.bulk_plan">
      <tr class="fw-medium">
        <td>
          {{ 'total_plan_cost' | translate }}
          ({{ price_summary.bulk_order_additional_info?.bulk_quantity }} qty)
        </td>
        <td class="text-end">
          {{ price_summary.bulk_order_additional_info?.bulk_plan?.total_cost_to_currency }}/mo.
        </td>
      </tr>
      <tr>
        <td>
          {{ price_summary.bulk_order_additional_info?.bulk_plan?.name }}
          (x{{ price_summary.bulk_order_additional_info?.bulk_plan?.quantity }}) &#64;
          {{
            price_summary.bulk_order_additional_info?.bulk_plan?.employee_cost_to_currency ||
              price_summary.bulk_order_additional_info?.bulk_plan?.cost_to_currency
          }}/mo.
        </td>
        <td class="text-end">
          {{ price_summary.bulk_order_additional_info?.bulk_plan?.total_cost_to_currency }}/mo.
        </td>
      </tr>
    </ng-container>
    <ng-container *ngIf="bulk_features_length">
      <tr class="fw-medium">
        <td>
          {{ 'total_feature_cost' | translate }}
          ({{ price_summary.bulk_order_additional_info?.bulk_features_quantity }} qty)
        </td>
        <td class="text-end">
          {{ price_summary.bulk_order_additional_info?.bulk_total_features_cost }}/mo.
        </td>
      </tr>
      <tr *ngFor="let feature of price_summary.bulk_order_additional_info?.bulk_features">
        <td>
          {{ feature.name }}
          (x{{ feature.quantity }}) &#64;
          {{ feature.employee_cost_to_currency || feature.cost_to_currency }}/mo.
        </td>
        <td class="text-end">{{ feature.total_cost_to_currency }}/mo.</td>
      </tr>
    </ng-container>
  </tbody>
</table>

<!-- Cost Per Bundle -->
<table
  *ngIf="price_summary.bulk_order_additional_info?.cost_per_bundle"
  class="table-sm w-100 mt-2rem"
>
  <thead class="row-cols-2">
    <th scope="col" class="h5 pb-2">{{ 'cost_per_bundle' | translate }}</th>
    <th scope="col" class="h5 pb-2"></th>
  </thead>
  <tbody class="table-group-divider border-light-subtle">
    <ng-container *ngIf="has_employee_one_time_costs">
      <tr class="fw-medium">
        <td>
          {{ 'one_time_costs' | translate }}
          ({{ (is_employee_payable ? 'employee' : 'company') | translate }})
        </td>
        <td class="text-end">
          {{ price_summary.bulk_order_additional_info?.cost_per_bundle?.total_one_time_cost }}
        </td>
      </tr>
      <tr *ngIf="price_summary.bulk_order_additional_info?.cost_per_bundle?.one_time_device_cost">
        <td>
          {{ 'device_cost' | translate }}
        </td>
        <td class="text-end">
          {{ price_summary.bulk_order_additional_info?.cost_per_bundle?.one_time_device_cost }}
        </td>
      </tr>
      <tr *ngIf="price_summary.bulk_order_additional_info?.cost_per_bundle?.add_ons_cost">
        <td>
          {{ 'add_ons_cost' | translate }}
        </td>
        <td class="text-end">
          {{ price_summary.bulk_order_additional_info?.cost_per_bundle?.add_ons_cost }}
        </td>
      </tr>
    </ng-container>
    <ng-container *ngIf="has_employee_recurring_costs">
      <tr class="fw-medium">
        <td>
          {{ 'recurring_costs' | translate }}
          ({{ 'company' | translate }})
        </td>
        <td class="text-end">
          {{ price_summary.bulk_order_additional_info?.cost_per_bundle?.total_recurring_cost }}/mo.
        </td>
      </tr>
      <tr *ngIf="price_summary.bulk_order_additional_info?.cost_per_bundle?.recurring_device_cost">
        <td>
          {{ 'device_cost' | translate }}
        </td>
        <td class="text-end">
          {{ price_summary.bulk_order_additional_info?.cost_per_bundle?.recurring_device_cost }}/mo.
        </td>
      </tr>
      <tr *ngIf="price_summary.bulk_order_additional_info?.cost_per_bundle?.plans_cost">
        <td>
          {{ 'plan_cost' | translate }}
        </td>
        <td class="text-end">
          {{ price_summary.bulk_order_additional_info?.cost_per_bundle?.plans_cost }}/mo.
        </td>
      </tr>
      <tr *ngIf="price_summary.bulk_order_additional_info?.cost_per_bundle?.features_cost">
        <td>
          {{ 'features_cost' | translate }}
        </td>
        <td class="text-end">
          {{ price_summary.bulk_order_additional_info?.cost_per_bundle?.features_cost }}/mo.
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
